"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProduct = updateProduct;
async function updateProduct(productRepo, product) {
    return await productRepo.updateProduct(product);
}
